/**
 * Footer newsletter: POST { email, birthdate } to Consuela subscribe API (legacy Mailchimp_events flow).
 */
function pad2(n) {
  const s = String(n).trim();
  if (s.length === 1) return `0${s}`;
  return s;
}

function showBanner(message, isError) {
  const el = document.createElement('div');
  el.setAttribute('role', 'status');
  el.style.cssText =
    'z-index:9999;position:fixed;top:0;left:0;right:0;padding:12px 16px;text-align:center;font-size:14px;' +
    (isError ? 'background:#7f1d1d;color:#fff;' : 'background:#14532d;color:#fff;');
  el.textContent = message;
  document.body.appendChild(el);
  setTimeout(() => {
    el.style.opacity = '0';
    el.style.transition = 'opacity 0.3s';
    setTimeout(() => el.remove(), 350);
  }, 5000);
}

function bindConsuelaNewsletterForm(form) {
  if (!form || form.dataset.consuelaNewsletterBound === 'true') return;
  form.dataset.consuelaNewsletterBound = 'true';

  const endpoint =
    form.getAttribute('data-subscribe-endpoint') ||
    'https://apisecondgen-pgqiwhy4hq-ew.a.run.app/web/subscribe';

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const messages = {
      success: form.dataset.msgSuccess,
      email_error: form.dataset.msgEmailError,
      birthday_error: form.dataset.msgBirthdayError,
      terms_error: form.dataset.msgTermsError,
      subscribe_error: form.dataset.msgSubscribeError,
    };

    const emailInput = form.querySelector('[name="EMAIL"]');
    const dayInput = form.querySelector('[name="BIRTHDAY[day]"]');
    const monthInput = form.querySelector('[name="BIRTHDAY[month]"]');
    const termsInput = form.querySelector('[name="accept_terms"]');

    const email = (emailInput?.value || '').trim();

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showBanner(messages.email_error || 'Invalid email', true);
      return;
    }

    let birthdate = '1900-01-01';
    if (dayInput && monthInput) {
      const day = pad2(dayInput.value || '');
      const month = pad2(monthInput.value || '');

      if (!day || !month || day.length !== 2 || month.length !== 2) {
        showBanner(messages.birthday_error || 'Invalid birthday', true);
        return;
      }

      const d = parseInt(day, 10);
      const m = parseInt(month, 10);
      if (d < 1 || d > 31 || m < 1 || m > 12) {
        showBanner(messages.birthday_error || 'Invalid birthday', true);
        return;
      }

      birthdate = `1900-${month}-${day}`;
    }

    if (termsInput && !termsInput.checked) {
      showBanner(messages.terms_error || 'Accept terms', true);
      return;
    }

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, birthdate }),
      });

      if (!res.ok) throw new Error('subscribe failed');

      showBanner(messages.success || 'Subscribed', false);
      form.reset();
    } catch {
      showBanner(messages.subscribe_error || 'Error', true);
    }
  });
}

function initConsuelaNewsletter() {
  document.querySelectorAll('form[data-consuela-newsletter]').forEach(bindConsuelaNewsletterForm);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initConsuelaNewsletter);
} else {
  initConsuelaNewsletter();
}

document.addEventListener('shopify:section:load', initConsuelaNewsletter);
